export const Team = [
    {
        value: "business_development_executive",
        label: "Business Development Executive",
    },
    { value: "relationship_manager", label: "Relationship Manager" },
];
